import React from "react";
import styled from "styled-components";
import PathwaySwitchInputGroup from "../../../../_UI/Components/Inputs/PathwaySwitchInputGroup";
import { Paragraph } from "../../../../_UI/StyledComponents/StyledComponents";
import PathwayTextInputGroup from "../../../../_UI/Components/Inputs/PathwayTextInputGroup";
import { LoadingSpinnerButton } from "../../../../_UI/Components/PathwayButtons";
import PhoneNumberInput from "../../../../_components/PhoneNumberInput";

const ShopifyAppstoreNewUserRegistration = (props) => {
    return (
        <UserGrid>
            <ModernFormGrid>
                <InputFieldContainer>
                    <FieldLabel>Shopify Store</FieldLabel>
                    <PathwayTextInputGroup
                        name={"organizationExternalUUID"}
                        handleChange={props.handleChange}
                        disabled={true}
                        value={props.shop}
                        dataCy="shopify-store-registration"
                    />
                </InputFieldContainer>
                <InputFieldContainer>
                    <FieldLabel>Vorname</FieldLabel>
                    <PathwayTextInputGroup
                        name={"firstName"}
                        dataCy="shopify-firstname-registration"
                        handleChange={props.handleChange}
                        value={props.newOrgAndUser.firstName}
                        mandatory
                        autoFocus
                    />
                </InputFieldContainer>
                <InputFieldContainer>
                    <FieldLabel>Nachname</FieldLabel>
                    <PathwayTextInputGroup
                        name={"lastName"}
                        dataCy="shopify-lastname-registration"
                        handleChange={props.handleChange}
                        value={props.newOrgAndUser.lastName}
                        mandatory
                    />
                </InputFieldContainer>
                <InputFieldContainer>
                    <FieldLabel>E-Mail</FieldLabel>
                    <PathwayTextInputGroup
                        name={"email"}
                        dataCy="shopify-email-registration"
                        handleChange={props.handleChange}
                        triggerOnBlur={props.handleEmailBlur}
                        value={props.newOrgAndUser.email}
                        mandatory
                    />
                    {props.emailError && <EmailErrorText>{props.emailError}</EmailErrorText>}
                </InputFieldContainer>
                <InputFieldContainer>
                    <PhoneNumberInput {...props.phoneInputProps} phoneInputDataCy="shopify-phonenumer-registration" />
                </InputFieldContainer>
                <InputFieldContainer>
                    <FieldLabel>Passwort</FieldLabel>
                    <PathwayTextInputGroup
                        name={"password"}
                        type="password"
                        dataCy="shopify-password-registration"
                        handleChange={props.handleChange}
                        value={props.newOrgAndUser.password}
                        mandatory
                    />
                </InputFieldContainer>
                <InputFieldContainer>
                    <FieldLabel>Passwort wiederholen</FieldLabel>
                    <PathwayTextInputGroup
                        name={"passwordRepeat"}
                        type="password"
                        dataCy="shopify-password-repeat-registration"
                        handleChange={props.handleChange}
                        value={props.newOrgAndUser.passwordRepeat}
                        mandatory
                    />
                </InputFieldContainer>
            </ModernFormGrid>
            <br />
            <LoginRow>
                <ModernSubmitButton
                    onClick={props.submit}
                    loading={props.appstoreSetup.shopifyNewUserLoading}
                    disabled={!props.newOrgAndUser.acceptTos || !props.newOrgAndUser.acceptDpa}
                    buttonCyData="shopify-user-registration-button"
                >
                    Jetzt registrieren
                </ModernSubmitButton>
                <br />
                <PathwaySwitchInputGroup
                    onChange={props.handleChange}
                    value={props.newOrgAndUser.acceptTos}
                    name="acceptTos"
                    dataCy="shopify-accepttos-registration"
                    label={
                        <Paragraph>
                            Ich stimme der{" "}
                            <a
                                href={
                                    "https://app.pathway-solutions.de/Nutzungsvereinbarung_Platform.pdf"
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Nutzungsvereinbarung
                            </a>{" "}
                            in der derzeit gültigen Fassung zu.
                        </Paragraph>
                    }
                />
                <PathwaySwitchInputGroup
                    onChange={props.handleChange}
                    value={props.newOrgAndUser.acceptDpa}
                    name="acceptDpa"
                    dataCy="shopify-acceptdpa-registration"
                    label={
                        <Paragraph>
                            Ich stimme dem Vertrag zur{" "}
                            <a
                                href={"https://app.pathway-solutions.de/AVV_Platform.pdf"}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Auftragsverarbeitung
                            </a>{" "}
                            zu.
                        </Paragraph>
                    }
                />
                <br />
            </LoginRow>
        </UserGrid>
    );
};

export default ShopifyAppstoreNewUserRegistration;

const EmailErrorText = styled.span`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin: 0;
    padding-top: var(--gap-s);
    color: #dc3545;
    font-size: var(--pw-text-sm);
`;

const UserGrid = styled.div`
    display: grid;
`;

const LoginRow = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
`;

const ModernFormGrid = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const InputFieldContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    .form-control {
        height: 45px !important;
        border-radius: 8px !important;
        border: 1px solid #d1d5db !important;
        font-family: "Inter", sans-serif !important;
        font-size: 16px !important;
        padding: 0 12px !important;
        transition:
            border-color 0.2s ease,
            box-shadow 0.2s ease !important;

        &:focus {
            border-color: #059669 !important;
            box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.1) !important;
            outline: none !important;
        }

        &:disabled {
            background-color: #f9fafb !important;
            color: #6b7280 !important;
        }
    }
`;

const FieldLabel = styled.label`
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
    margin-bottom: 0.25rem;
`;

const ModernSubmitButton = styled(LoadingSpinnerButton)`
    background: #059669 !important;
    border: 1px solid #059669 !important;
    border-radius: 8px !important;
    height: 45px !important;
    min-height: 45px !important;
    max-height: 45px !important;
    line-height: 43px !important;
    font-family: "Inter", sans-serif !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    color: white !important;
    transition: all 0.2s ease !important;
    width: 100% !important;
    padding: 0 16px !important;
    box-sizing: border-box !important;

    &,
    &.btn,
    &.btn-primary,
    &.btn-block {
        height: 45px !important;
        min-height: 45px !important;
        max-height: 45px !important;
        line-height: 43px !important;
    }

    &:hover:not(:disabled) {
        background: #047857 !important;
        border-color: #047857 !important;
        transform: translateY(-1px) !important;
        box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3) !important;
    }

    &:focus {
        outline: none !important;
        box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.1) !important;
    }

    &:disabled {
        background: #d1d5db !important;
        border-color: #d1d5db !important;
        cursor: not-allowed !important;
        transform: none !important;
        box-shadow: none !important;
    }

    &:active {
        transform: translateY(0) !important;
    }
`;
